var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.881,
    height: 40,
    viewBox: "0 0 44.881 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zip_folder",
    transform: "translate(0 -3.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3813",
    "data-name": "Path 3813",
    d: "M43.52,13.536H1.36V6.32A1.472,1.472,0,0,1,2.833,4.847H12.854a.146.146,0,0,1,.112.056l2.5,3.2a1.5,1.5,0,0,0,1.185.575H42.048a1.472,1.472,0,0,1,1.473,1.473v3.387ZM42.048,7.309H16.655a.15.15,0,0,1-.119-.056l-2.5-3.191a1.491,1.491,0,0,0-1.185-.582H2.833A2.84,2.84,0,0,0,0,6.32V40.654A2.833,2.833,0,0,0,2.833,43.48H42.048a2.833,2.833,0,0,0,2.833-2.826v-30.5a2.84,2.84,0,0,0-2.833-2.84ZM43.52,40.654a1.477,1.477,0,0,1-1.473,1.473H2.833A1.477,1.477,0,0,1,1.36,40.654V14.89h20.4V16.5H19.467a.68.68,0,1,0,0,1.36H21.76v2.181H19.467a.68.68,0,0,0,0,1.36H21.76v2.181H19.467a.68.68,0,0,0,0,1.36H21.76v2.174H19.467a.68.68,0,1,0,0,1.36H21.76v3.093a.68.68,0,1,0,1.36,0V28.473h2.293a.68.68,0,1,0,0-1.36H23.121V24.939h2.293a.68.68,0,0,0,0-1.36H23.121V21.4h2.293a.68.68,0,1,0,0-1.36H23.121V17.856h2.293a.68.68,0,1,0,0-1.36H23.121V14.89h20.4Z",
    fill: "#2d72ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3814",
    "data-name": "Path 3814",
    d: "M23.7,19.75v1.606h2.293a.68.68,0,1,1,0,1.36H23.7V24.9h2.293a.68.68,0,0,1,0,1.36H23.7v2.181h2.293a.68.68,0,0,1,0,1.36H23.7v2.174h2.293a.68.68,0,1,1,0,1.36H23.7v3.093a.68.68,0,1,1-1.36,0V33.333H20.047a.68.68,0,1,1,0-1.36H22.34V29.8H20.047a.68.68,0,0,1,0-1.36H22.34V26.258H20.047a.68.68,0,1,1,0-1.36H22.34V22.716H20.047a.68.68,0,0,1,0-1.36H22.34V19.75H1.94V45.507A1.477,1.477,0,0,0,3.413,46.98H42.627A1.477,1.477,0,0,0,44.1,45.507V19.75ZM26.674,45a.681.681,0,0,1-.68.68H20.047a.68.68,0,0,1-.68-.68v-5.94a.685.685,0,0,1,.68-.68h5.947a.685.685,0,0,1,.68.68Z",
    transform: "translate(-0.58 -4.86)",
    fill: "rgba(246,214,126,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3815",
    "data-name": "Path 3815",
    d: "M44.1,10.725v3.387H1.94V6.9A1.472,1.472,0,0,1,3.413,5.43H13.434a.146.146,0,0,1,.112.056l2.5,3.2a1.5,1.5,0,0,0,1.185.575H42.627A1.467,1.467,0,0,1,44.1,10.725Z",
    transform: "translate(-0.58 -0.583)",
    fill: "rgba(247,200,96,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3816",
    "data-name": "Path 3816",
    d: "M33.417,46.33H27.47a.685.685,0,0,0-.68.68v5.94a.681.681,0,0,0,.68.68h5.947a.681.681,0,0,0,.68-.68V47.01a.68.68,0,0,0-.68-.68Zm-.68,5.947H28.15V47.69h4.586Z",
    transform: "translate(-8.003 -12.801)",
    fill: "rgba(49,130,193,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3817",
    "data-name": "Path 3817",
    d: "M28.73,48.26h4.586v4.586H28.73Z",
    transform: "translate(-8.583 -13.377)",
    fill: "#fce9bf"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.7f1213e0537412312e2c8bbc9102e05b.svg";
export { ForwardRef as ReactComponent };